import axios from 'axios'
import { i18n } from 'next-i18next'

const instance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASEURL,
  withCredentials: true,
})

instance.interceptors.request.use(
  (config) => {
    // Modify the request here
    config.headers['Accept-Language'] = i18n?.language

    const isSSR = typeof window === 'undefined'
    if (isSSR && process.env.NEXT_PUBLIC_GATEWAY_API_BASEURL) {
      config.baseURL = process.env.NEXT_PUBLIC_GATEWAY_API_BASEURL
      config.headers['x-ssr-call'] = '1'
      config.headers['Proxy-Authorization'] =
        'Bearer ' + process.env.PROXY_AUTH_TOKEN
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

export default instance
